export default [
    {
        path: '/questionnaire_form/:id',
        name: 'questionnaire_form',
        component: () => import('@/views/quality/questionnaires_forms/index'),
        meta: { pageTitle: 'questionnaire_form', breadcrumb: [{ text: 'questionnaire_form' }] },
    },
]
